import type { Address } from '@/store/userInfo';
import type { AddProductData, EditAddressForm } from '../types';
import { http } from '../core/http';

/**
 * 我的订单
 * @export
 * @param {Object} params - 
 * @param {string} [params.page] - 分页参数
 * @param {string} [params.os] - 订单类别 0:全部 daifa待发 daishou待收 yiwancheng已完成 shouhou售后 daifu待付
 * @param {string} [params.key] - 订单号
 * @returns
 */
export async function getOrderDetail(params: any) {
  return await http.post('/api/member/order', params);
}

/**
 * 订单管理
 * @export
 * @param {Object} params - 
 * @param {string} [params.page] - 分页参数
 * @param {string} [params.os] - 订单类别 0:全部 daifa待发 daishou待收 yiwancheng已完成 shouhou售后 daifu待付
 * @param {string} [params.key] - 订单号
 * @returns
 */
export async function getNewOrderDetail(params: any) {
  // return await http.post('/api/order/orderNew2', params);
  return await http.post('/index.php?route=vapi/order/orderNew2', params);
}

/** Load products beyond the two-item order preview. */
export async function getThirdOrderProducts(params: {
  order_id: number | string
  offset?: number
  limit?: number
  token?: string
}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/orderThirdProducts', params)
}

/** Load the remaining products of one self order after the list preview. */
export async function getSelfOrderProducts(params: {
  order_id: number | string
  offset?: number
  limit?: number
  token?: string
}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/orderSelfProducts', params)
}

/**
 * TEMU半托管订单邮编推荐仓筛选选项。
 */
export async function getPostcodeRecommendWarehouses({
  store_id = '',
  keyword = '',
}: {
  store_id?: number | string
  keyword?: string
} = {}): Promise<any> {
  return await http.get('/index.php?route=customer/temusemi/postcodeRecommendWarehouses', {
    params: { store_id, keyword },
  })
}

/**
 * 订单类型
 * @export
 * @param {Object} params - 
 * @param {string} [params.page] - 分页参数
 * @param {string} [params.os] - 订单类别 0:全部 daifa待发 daishou待收 yiwancheng已完成 shouhou售后 daifu待付
 * @param {string} [params.key] - 订单号
 * @returns
 */
export async function getOrderType(params: any) {
  // return await http.post('/api/order/getOrdertype', params);
  return await http.post('/index.php?route=vapi/order/getOrdertype', params);
}

/**
 * 订单进度
 * @export
 * @param {Object} params - 
 * @param {string} [params.page] - 分页参数
 * @param {string} [params.os] - 订单类别 0:全部 daifa待发 daishou待收 yiwancheng已完成 shouhou售后 daifu待付
 * @param {string} [params.key] - 订单号
 * @returns
 */
export async function getOrderOperation(params: any) {
  // return await http.post('/api/order/orderOperation', params);
  return await http.post('/index.php?route=vapi/order/orderOperation', params);
}


/**
 * 取消
 * @export
 * @param {Object} [params]
 * @param {integer} [params.orderid]
 * @param {integer} [params.type] 1余额支付 2支付宝支付
 * @param {string} [params.token]
 */
export async function cancelProduct({ orderid = '', order_status = 14, token = '' } = {}): Promise<any> {
  // return await http.post('/api/order/updateOrderStatus',{orderid,order_status,token})
  return await http.post('/index.php?route=vapi/order/updateOrderStatus', { orderid, order_status, token })
}



/**
 * 订单申请退货、退款
 * @export
 * @param {Object} [params]
 * @param {integer} [params.ordernum] 订单号
 * @param {integer} [params.reason] 申请原因
 * @param {integer} [params.tui_type] 5申请退货 7申请退款 
 * @param {string} [params.token]
 */
export async function getTuiOrder({ ordernum = '', reason = '', tui_type = 7, token = '' } = {}): Promise<any> {
  // return await http.post('/api/order/tuiOrder',{ordernum,reason,tui_type,token})
  return await http.post('/index.php?route=vapi/order/tuiOrder', { ordernum, reason, tui_type, token })
}

/**
 * 查看物流
 * @export
 * @param {Object} [params]
 * @param {integer} [params.ordernum] 订单号
 * @param {string} [params.token]
 */
export async function seeWuliu({ ordernum = '', token = '' } = {}): Promise<any> {
  // return await http.post('/api/order/see_wuliu',{ordernum,token})
  return await http.post('/index.php?route=vapi/order/see_wuliu', { ordernum, token })
}

/**
 * 确认订单操作
 * @export
 * @param {Object} [params]
 * @param {integer} [params.orderid] 订单id
 * @param {integer} [params.ordernum_other] 第三方订单编号
 * @param {string} [params.token]
 */
export async function orderSure({ deliveryAddressId = '', orderid = '', ordernum_other = '', token = '', factoryid = '', force = 0, total_code = '', total_number = 0, shipping_code = '' } = {}): Promise<any> {
  // return await http.post('/api/order/orderSure',{orderid,ordernum_other,token,factoryid,force})
  return await http.post('/index.php?route=vapi/order/orderSure', { deliveryAddressId, orderid, ordernum_other, token, factoryid, force, total_code, total_number, shipping_code })
}


/**
 * 订单待付款状态支付
 *
*/
export async function unpaidPayment({ orderid = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/unpaidPayment', { orderid })
}


export async function orderSureNew({ orderid = '', ordernum_other = '', token = '', factoryid = '', force = 0, shipping_method = '' } = {}): Promise<any> {
  // return await http.post('/api/order/orderSureNew',{orderid,ordernum_other,token,factoryid,force})
  return await http.post('/index.php?route=vapi/order/orderSureNew', { orderid, ordernum_other, token, factoryid, force, shipping_method })
}


/**
 * 订单合并产品条形码
 * @export
 * @param {Object} [params]
 * @param {integer} [params.orderid] 订单id
 * @param {string} [params.token]
 */
export async function mergeSku({ lan_id = '', order_status = 0 } = {}): Promise<any> {
  // return await http.post('/api/order/merge_sku',{lan_id,order_status})
  return await http.post('/index.php?route=vapi/order/merge_sku', { lan_id, order_status })
}

/**
 * 地址列表
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getAddressList({ page = 1 } = {}): Promise<{
  code,
  msg,
  data: {
    data: Address[],
    page: number,
    recordsTotal: number,
    recordsFiltered: number
  },
}> {
  // return await http.post('/api/member/address',{page})
  return await http.post('/index.php?route=vapi/address/getAddressList', { page })
}


/**
 * 新增或修改地址
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function addAndUpdateAddress(form: EditAddressForm): Promise<any> {
  // return await http.post('/api/member/address_update',{saveid,province,city,xian,zipcode,address_detail,uname,tel})
  return http.post('/index.php?route=vapi/address/addAndUpdateAddress', form)
}


/**
 * 新增地址
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function addAddress({ saveid = '', province = '', city = '', xian = '', zipcode = '', address_detail = '', uname = '', tel = '', country = '' } = {}): Promise<any> {
  // return await http.post('/api/member/address_update',{saveid,province,city,xian,zipcode,address_detail,uname,tel})
  return await http.post('/index.php?route=vapi/address/addAddress', { saveid, province, city, xian, zipcode, address_detail, uname, tel, country })
}


/**
 * 删除地址
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function delAddress({ aid = '' } = {}): Promise<any> {
  // return await http.post('/api/member/address_del',{aid})
  return await http.post('/index.php?route=vapi/address/delAddress', { aid })
}

export async function delPdf(): Promise<any> {
  return await http.post('/index.php?route=checkout/checkout/delPdf')
}

/**
 * 省市区获取
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getArea({ aid = 0 } = {}): Promise<any> {
  // return await http.post('/api/member/area',{aid})
  return await http.post('/index.php?route=vapi/address/getArea', { aid })
}

/**
 * 全球省市区获取
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getGlobalArea({ aid = 0, countryId = 0, zid = 0, cid = 0 } = {}): Promise<any> {
  // return await http.post('/api/member/area',{aid})
  return await http.post('/index.php?route=vapi/address/getGlobalArea', { aid, countryId, zid, cid })
}

//购物车、结算删除pdf
export async function deletePdf(params: any): Promise<any> {
  return await http.post('/index.php?route=vapi/carts/deletePdf', params);
}

/**
* 订单管理-备注
* @export
* @param {Object} [params] - 
* @returns
*/
export async function orderMark({ oid = '', ordermark = '' }): Promise<any> {
  // return await http.post('/api/order/ordermarkset',{oid,ordermark});
  return await http.post('/index.php?route=vapi/order/ordermarkset', { oid, ordermark });
}

/**
* 订单管理-工厂备注
* @export
* @param {Object} [params] - 
* @returns
*/
export async function factory_Mark({ oid = '', factory_remark = '' }): Promise<any> {
  // return await http.post('/api/order/ordermarkset',{oid,ordermark});
  return await http.post('/index.php?route=vapi/order/factoryRemark', { oid, factory_remark });
}


/**
 * 订单管理-修改地址
 * @param form 
 * @returns 
 */
export async function changeAddress(form: { aid: number | string, order_id: number | string }): Promise<any> {
  return http.post('/index.php?route=vapi/order/changeAddress', form);
}


/**
 * 订单管理-添加成品
 * @param form 
 * @returns 
 */
export async function addOrderProduct(form: Required<AddProductData>): Promise<any> {
  return http.post('/index.php?route=vapi/order_product/addOrderProduct', form);
}

/**
* 订单管理-商品备注
* @export
* @param {Object} [params] - 
* @returns
*/
export async function factoryProduct({ order_product_id = '', otherid = '', good_remark = '' }): Promise<any> {
  // return await http.post('/api/order/ordermarkset',{oid,ordermark});
  return await http.post('/index.php?route=vapi/order/saveGoodRemark', { order_product_id, otherid, good_remark });
}

/**
* 订单管理-标记备货
* @export
* @param {Object} [params] - 
* @returns
*/
export async function changeStockUp({ order_id = '', stock_up = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order/changeStockUp', { order_id, stock_up });
}

/**
* 订单管理-更新预计发货时间
* @export
* @param {Object} [params] - 
* @returns
*/
export async function updateExpectedDeliveryTime({ order_id = '', expected_delivery_time = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/updateExpectedDeliveryTime', { order_id, expected_delivery_time });
}

/**
* 订单管理-获取定位
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getHandxy({ sku = '', size = '', buliao = '' }): Promise<any> {
  // return await http.post('/api/order/gethandxy',{sku,size});
  return await http.post('/index.php?route=vapi/order_push/gethandxy', { sku, size, buliao });
}

/**
* 订单管理-拆分
* @export
* @param {Object} [params] - 
* @returns
*/
export async function orderSplit({ otherid = '', splitarr = '' }): Promise<any> {
  return await http.post('/api/order/ordersplit', { otherid, splitarr });
}


/**
* 订单管理-拆分
* @export
* @param {Object} [params] - 
* @returns
*/
export async function splitOrder(form: { order_id: string | number, other_id: string | number, split_data: AddProductData[] }): Promise<any> {
  return await http.post('/index.php?route=vapi/order_product/splitOrder', form);
}


/**
* 订单管理-复制
* @export
* @param {Object} [params] - 
* @returns
*/
export async function orderCopy({ otherid = '' }): Promise<any> {
  // return await http.post('/api/order/ordercopy',{otherid});
  return await http.post('/index.php?route=vapi/order/ordercopy', { otherid });
}

/**
* 订单管理-改成品ID
* @export
* @param {Object} [params] - 
* @returns
*/
export async function changeSkuId({ otherid = '', newskuid = '', type = 1 }): Promise<any> {
  // return await http.post('/api/order/changeskuid',{otherid,newskuid});
  return await http.post('/index.php?route=vapi/order/changeskuid', { otherid, newskuid, type });
}

/**
* 上传pdf
*/
export async function uploadPdf({ orderid = '', filecode = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order/uploadPdf', { orderid, filecode });
}

/**
* 我的商品-商家
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getFactory(): Promise<any> {
  // return await http.post('/api/order/getfactory');
  return await http.post('/index.php?route=vapi/order/getfactory');
}

/**
* 我的商品-恢复搁置
* @export
* @param {Object} [params] - 
* @returns
*/
export async function orderReturn({ orderid = '' }): Promise<any> {
  // return await http.post('/api/order/orderreturn',{orderid});
  return await http.post('/index.php?route=vapi/order/orderreturn', { orderid });
}

/**
* 我的商品-返回设计
* @export
* @param {Object} [params] - 
* @returns
*/
export async function backToDesign({ orderid = '', otherid = '' }): Promise<any> {
  // return await http.post('/api/order/backtodesign',{orderid});
  return await http.post('/index.php?route=vapi/order/backtodesign', { orderid, otherid });
}

/**
* 我的商品-删除订单
* @export
* @param {Object} [params] - 
* @returns
*/
export async function orderDelone({ otherid = '' }): Promise<any> {
  // return await http.post('/api/order/orderdelone',{otherid});
  return await http.post('/index.php?route=vapi/order/orderdelone', { otherid });
}


export async function getShippingMethodsNewTwo() {
  return await http.post('/index.php?route=vapi/order/getShippingMethodsNewTwo');
}



/**
* 更新购物车订单销售价格
* @export
* @param {Object} [params] - 
* @returns
*/
export async function saveOrderSalePrice(params: any): Promise<any> {
  return await http.post('/index.php?route=vapi/order/saveOrderSalePrice', params);
}




/**
 * 速卖通确认接单
 * @export
 * @param {Object} [params]
 * @param {integer} [params.orderid]
 * @param {integer} [params.type] 1余额支付 2支付宝支付
 * @param {string} [params.token]
 */
export async function aliexpressCurchaseOrder({ orderid = '', token = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/aliexpressCurchaseOrder', { orderid, token })
}


/**
 * 获取订单导入模板
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getImportTemplate({ } = {}): Promise<any> {
  // return await http.post('/api/order/customer_code_get',{cid})
  return await http.get('/index.php?route=vapi/import/prod_drawing/getImportTemplate', {})
}

/**
 * 上传订单导入表格
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function uploadExcel({ file = '' } = {}): Promise<any> {
  // return await http.post('/api/order/customer_code_get',{cid})
  return await http.post('/index.php?route=vapi/import/prod_drawing/uploadExcel', { file })
}

/**
 * 导入订单
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function importOrder_item({ import_id = '' } = {}): Promise<any> {
  // return await http.post('/api/order/customer_code_get',{cid})
  return await http.post('/index.php?route=vapi/import/prod_drawing/importOrder', { import_id })
}

/**
 * 获取订单导入记录
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getImportRecords({ page = '' } = {}): Promise<any> {
  // return await http.post('/api/order/customer_code_get',{cid})
  return await http.get('/index.php?route=vapi/import/prod_drawing/getImportRecords', { params: { page } })
}

/**
 * 订单导入前验证是否已导入过
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function importOrderCheck({ original_name = '' } = {}): Promise<any> {
  // return await http.post('/api/order/customer_code_get',{cid})
  return await http.post('/index.php?route=vapi/order/importOrderCheck', { original_name })
}

/**
 * 订单导出
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getexportOrder({ token = '', order_ids = '' } = {}): Promise<any> {
  // return await http.post('/api/order/customer_code_get',{cid})
  return await http.get('/index.php?route=vapi/order/exportOrder', { params: { token, order_ids } })
}

/**
 * 获取订单商品详情、查看订单生产流程
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getProductDetail({ token = '', page = '', limit = '', order_id = '', finish_type = '' } = {}): Promise<any> {
  // return await http.post('/api/order/customer_code_get',{cid})
  return await http.post('/index.php?route=vapi/product/getProductDetail', { token, page, limit, order_id, finish_type })
}

/**
 * 获取订单生产进度 
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getProductStatus({ token = '', page = '', limit = '', order_id = '', finish_type = '' } = {}): Promise<any> {
  // return await http.post('/api/order/customer_code_get',{cid})
  return await http.post('/index.php?route=vapi/product/getProductStatus', { token, page, limit, order_id, finish_type })
}

/**
 * 订单管理 shopee添加获取面单
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function createPdf({ order_source = '', orderid = '' } = {}): Promise<any> {
  // return await http.post('/api/order/customer_code_get',{cid})
  return await http.post('/index.php?route=vapi/order/createPdf', { order_source, orderid })
}

/**
 *temu订单获取发货仓库   
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getTemuMallAddress({ order_source = '', orderids = '' } = {}): Promise<any> {
  // return await http.post('/api/order/customer_code_get',{cid})
  return await http.post('/index.php?route=customer/order/getTemuMallAddress', { order_source, orderids })
}

/**
 *temu订单创建发货单
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function temuCreateShiporder({ order_source = '', orderids = ''} = {}): Promise<any> {
  // return await http.post('/api/order/customer_code_get',{cid})
  return await http.post('/index.php?route=customer/order/temuCreateShiporder', { order_source, orderids })
}

/**
 *获取第三方物流公司
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function temuLogisticsList({ order_source = '', orderid = '', deliveryAddressId = '', subWarehouseId = '', deliveryOrderSn = '', totalPackageNum = '', predictTotalPackageWeight = '', receiveAddressInfo = {} } = {}): Promise<any> {
  // return await http.post('/api/order/customer_code_get',{cid})
  return await http.post('/index.php?route=customer/order/temuLogisticsList', { order_source, orderid, deliveryAddressId, subWarehouseId, deliveryOrderSn, totalPackageNum, predictTotalPackageWeight, receiveAddressInfo })
}

/**
 * 装箱发货
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function temuShiporderPackingSend({ deliveryOrderSns = '', deliveryContactNumber = '', predictTotalPackageWeight = '', pickupDate = '', order_source = '', orderids = '', deliveryAddressId = '', deliverMethod = '', expressCompanyId = '', expressCompanyName = '', totalPackageNum = '', driverName = '', plateNumber = '', subWarehouseId = '', predictId = '' } = {}): Promise<any> {
  // return await http.post('/api/order/customer_code_get',{cid})
  return await http.post('/index.php?route=customer/order/temuShiporderPackingSend', { deliveryOrderSns, deliveryContactNumber, predictTotalPackageWeight, pickupDate, order_source, orderids, deliveryAddressId, deliverMethod, expressCompanyId, expressCompanyName, totalPackageNum, driverName, plateNumber, subWarehouseId, predictId })
}


/**
 * 修改订单商品条码
 * @export
 * 
 */
export async function saveOrderProductCode(sku_code: string, product_code: string, order_product_id: string) {
  return await http.post('/index.php?route=vapi/order/saveProductCode', { sku_code, product_code, order_product_id });
}


/**
 * 修改商品条码
 * @param sku_code 
 * @param product_code 
 * @param order_product_id 
 * @returns 
 */
export async function saveOtherProductCode(sku_code: string, product_code: string, otherid: string) {
  return http.post('/index.php?route=vapi/order/saveProductCode', { sku_code, product_code, otherid });
}

/** 修改白名单 Amazon 订单商品 SKU，并触发成品匹配。 */
export async function saveAmazonOrderSku({
  order_id,
  line_id,
  sku,
  expected_sku,
}: {
  order_id: string | number
  line_id: string | number
  sku: string
  expected_sku: string
}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/saveAmazonOrderSku', {
    order_id,
    line_id,
    sku,
    expected_sku,
  })
}

/**
 * 订单管理：批量取消订单
 * @param orderids 
 * @returns 
 */
export async function batchCancel({ orderids = '', } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/batchCancel', { orderids })
}

/**
 * 6、查询发货单信息
 * @param orderids 
 * @returns 
 */
export async function getTemuShiporders({ orderids = '', order_source = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=customer/order/getTemuShiporders', { orderids, order_source })
}

/**
 * 订单管理：上传订单PDF
 * @param orderids 
 * @returns 
 */
export async function uploadOrderPdf({ file = '', order_id = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/upload_pdf/uploadOrderPdf', { file, order_id })
}

/**
 * 订单管理：上传订单商品PDF
 * @param orderids 
 * @returns 
 */
export async function uploadOrderProductPdf({ file = '', order_id = '', order_product_id = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/upload_pdf/uploadOrderProductPdf', { file, order_id, order_product_id })
}

/**
 * 订单管理：删除订单PDF或订单商品PDF
 * @param orderids 
 * @returns 
 */
export async function upload_pdfdelPdf(params: any): Promise<any> {
  return await http.post('/index.php?route=vapi/upload_pdf/delPdf', params)
}

/**
 * 订单管理：手动推单
 * @param orderids 
 * @returns 
 */
export async function getHandLastRecord({ sku = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order_push/getHandLastRecord', { sku })
}

/**
 * 订单管理 temu新增创建发货台
 * @param orderids 
 * @returns 
 */
export async function addShiporderStaging({ order_source = '', orderids = '', deliveryAddressId = '', deliveryAddressLabel = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/order/addShiporderStaging', { order_source, orderids, deliveryAddressId, deliveryAddressLabel })
}

/**
 * 订单管理 手动同步订单
 * @param orderids 
 * @returns 
 */
export async function syncOrder({ platform = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/order/syncOrder', { platform })
}

/**
 * 订单管理 待确认 单个付款和批量付款
 * @param orderids 
 * @returns 
 */
export async function getShippingMethods({ order_id = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order/getShippingMethods', { order_id })
}

/**
 * 订单管理 待设计图片显示
 * @param orderids 
 * @returns 
 */
export async function getYiSheJj({ order_id = '', other_id = '', order_product_id = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/order/getYiSheJj', { order_id, other_id, order_product_id })
}

/**
 * 订单管理 申请运单号 获取订单对应的物流仓库
 * @param orderids 
 * @returns 
 */
export async function getShippingservices({ orderid = '', warehouseId = '', weight = '', weightUnit = '', length = '', width = '', height = '', dimensionUnit = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/temusemi/getShippingservices', { orderid, warehouseId, weight, weightUnit, length, width, height, dimensionUnit })
}

/**
 * 订单管理 退货/退款
 * @param orderids 
 * @returns 
 */
export async function getOrderProducts({ order_id = '' }): Promise<any> {
  return await http.post('/index.php?route=vapi/return/getOrderProducts', { order_id })
}

/**
 * 订单管理 退货/退款 原因
 * @param orderids 
 * @returns 
 */
export async function getReturnReason({ }): Promise<any> {
  return await http.get('/index.php?route=vapi/return/getReturnReason', { params: {} })
}

/**
 * 订单管理新 查看物流
 * @export
 * @param {Object} [params]
 * @param {integer} [params.ordernum] 订单号
 * @param {string} [params.token]
 */
export async function queryItsTrack({ waybillNo = '' }): Promise<any> {
  return await http.get('/index.php?route=customer/temusemi/queryItsTrack', { params: { waybillNo } })
}

/**
 * 订单管理 申请运单号 申请Y2订单发货单
 * @param orderids 
 * @returns 
 */
export async function applyShipping(params: any): Promise<any> {
  return await http.post('/index.php?route=customer/temusemi/applyShipping', params)
}

/**
 * 订单管理 申请运单号 获取订单对应的发货信息
 * @param orderids 
 * @returns 
 */
export async function queryOrderInfos({ order_ids = '', warehouseId = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/temusemi/queryOrderInfos', { order_ids, warehouseId })
}

/**
 * 订单管理 申请运单号 获取Y2发货仓对应的物流列表
 * @param orderids 
 * @returns 
 */
export async function orderWarehouse({ order_ids = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/temusemi/orderWarehouse', { order_ids })
}

/**
 * 订单管理 Tiktok全托管 创建送货单
 * @param orderids 
 * @returns 
 */
export async function deliveryTkgbOrders({ orderids = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/order/deliveryTkgbOrders', { orderids })
}


/**
 * 订单管理 Tiktok全托管 送货单列表查询
 * @param orderids 
 * @returns 
 */
export async function tkGbDeliveryOrdersSearch({ orderids = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/order/tkGbDeliveryOrdersSearch', { orderids })
}

/**
 * 订单管理 Tiktok全托管 商家地址列表查询
 * @param orderids 
 * @returns 
 */
export async function tkGbSupplierAddresses({ orderids = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/order/tkGbSupplierAddresses', { orderids })
}

/**
 * 订单管理 Tiktok全托管 可用物流商与预约日期查询
 * @param orderids 
 * @returns 
 */
export async function tkGbShippingProviders(params: any) {
  return await http.post('/index.php?route=customer/order/tkGbShippingProviders', params);
}

/**
 * 订单管理 Tiktok全托管 预约发货
 * @param orderids 
 * @returns 
 */
export async function tkGbReserveShip(params: any) {
  return await http.post('/index.php?route=customer/order/tkGbReserveShip', params);
}

/**
 * tiktok全托管 确认送货
 * @param orderids 
 * @returns 
 */
export async function tkGbDeliveryConfirm({ orderids = '' }): Promise<any> {
  return await http.post('/index.php?route=customer/order/tkGbDeliveryConfirm', { orderids })
}

/**
 * 订单：顺丰物流重新获取面单
 * @export
 * @param {Object} [params]
 */
export async function sfglobal_createOrder({ order_ids = '', }): Promise<any> {
  return await http.post('/index.php?route=customer/sfglobal/createOrder', { order_ids })
}

/**
 * 订单：云途物流重新获取面单
 * @export
 * @param {Object} [params]
 */
export async function yunexpress_createOrder({ order_ids = '', }): Promise<any> {
  return await http.post('/index.php?route=customer/yunexpress/createOrder', { order_ids })
}

/**
 * 订单：tiktok直邮店 获取订单对应的可选物流方式
 * @export
 * @param {Object} [params]
 */
export async function getShippingProviders(params: any = {}): Promise<any> {
  const { orderids = '' } = params
  return await http.post('/index.php?route=customer/tiktok/getShippingProviders', { orderids })
}

/**
 * 订单：tiktok直邮店虚拟发货
 * @export
 * @param {Object} [params]
 */
export async function markPackageShipped(params: any) {
  return await http.post('/index.php?route=customer/tiktok/markPackageShipped', params);
}

/**
 * 将单个 Amazon 订单提交到发货同步队列。
 * @param orderid ERP 订单 ID
 */
export async function markAmazonOrderShipped({
  orderid = '',
}: {
  orderid?: number | string
} = {}): Promise<any> {
  return await http.post('/index.php?route=customer/amazon/markOrderShipped', { orderid })
}

/**
 * 将多个 Amazon 订单提交到发货同步队列。
 * @param orderids ERP 订单 ID 列表
 */
export async function markAmazonOrdersShipped({
  orderids = [],
}: {
  orderids?: Array<number | string>
} = {}): Promise<any> {
  return await http.post('/index.php?route=customer/amazon/markOrdersShipped', { orderids })
}

/**
 * 订单：批量重新获取面单
 * @export
 * @param {Object} [params]
 */
export async function reapplyShipping({ order_ids = '', }): Promise<any> {
  return await http.post('/index.php?route=customer/order/reapplyShipping', { order_ids })
}

/**
 * 订单：shein取店铺仓库/寄件地址列表
 * @export
 * @param {Object} [params]
 */
export async function sheinSelfWarehouseAddress(params: any) {
  return await http.post('/index.php?route=customer/order/sheinSelfWarehouseAddress', params);
}


/**
 * 订单：shein获取物流渠道
 * @export
 * @param {Object} [params]
 */
export async function sheinSelfOrderMappingChannels(params: any) {
  return await http.post('/index.php?route=customer/order/sheinSelfOrderMappingChannels', params);
}

/**
 * 订单：shein在线下单 
 * @export
 * @param {Object} [params]
 */
export async function sheinSelfPlaceExpressOrder(params: any) {
  return await http.post('/index.php?route=customer/order/sheinSelfPlaceExpressOrder', params);
}

/**
 * 订单：修改订单收货地址
 * @export
 * @param {Object} [params]
 */
export async function updateAddress(params: any) {
  return await http.post('/index.php?route=vapi/order/updateAddress', params);
}

/**
 * 订单：获取订单收货地址
 * @export
 * @param {Object} [params]
 */
export async function getAddress({ orderid = '' }): Promise<any> {
  return await http.get('/index.php?route=vapi/order/getAddress', { params: { orderid } })
}

/**
 * 订单：批量修改物流预览
 * @export
 * @param {Object} [params]
 */
export async function changeShippingPreview(params: any) {
  return await http.post('/index.php?route=vapi/order/changeShippingPreview', params);
}

/**
 * 订单：批量修改物流-确认提交
 * @export
 * @param {Object} [params]
 */
export async function changeShippingConfirm(params: any) {
  return await http.post('/index.php?route=vapi/order/changeShippingConfirm', params);
}

/**
 * 订单：恢复取消订单 
 * @export
 * @param {Object} [params]
 */
export async function restoreCanceledOrder({ orderid = '', }): Promise<any> {
  return await http.post('/index.php?route=vapi/order/restoreCanceledOrder', { orderid })
}

/**
 * 订单批量下载pdf
 * @export
 * @param {Object} [params]
 */
export async function exportOrderPdf({ orderids = '', }): Promise<any> {
  return await http.post('/index.php?route=vapi/order/exportOrderPdf', { orderids })
}

/**
 * 订单：希音自运营手动同步指定订单
 * @export
 * @param {Object} [params]
 */
export async function syncSheinSelfOrderByOrderNo({
  storeId = '',
  orderNos = [] as string[],
}: {
  storeId?: number | string
  orderNos?: string[]
} = {}): Promise<any> {
  return await http.post('/index.php?route=customer/order/syncSheinSelfOrderByOrderNo', { storeId, orderNos })
}

/**
 * 订单：希音自运营手动同步指定订单-excel表格
 * @export
 * @param {Object} [params]
 */
export async function syncSheinSelfOrderByExcel({
  storeId,
  file,
}: {
  storeId: number | string
  file: File
}): Promise<any> {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('storeId', String(storeId))
  return await http.post('/index.php?route=customer/order/syncSheinSelfOrderByExcel', formData)
}

/**
 * 订单：希音自运营手动同步店铺订单
 * @export
 * @param {Object} [params]
 */
export async function syncSheinSelfOrderByCondition({
  storeId = '',
  startTime = '',
  endTime = '',
  orderStatus = '',
}: {
  storeId?: number | string
  startTime?: string
  endTime?: string
  orderStatus?: number | string
} = {}): Promise<any> {
  return await http.post('/index.php?route=customer/order/syncSheinSelfOrderByCondition', { storeId, startTime, endTime, orderStatus })
}

/**
* 订单管理-批量修改客户留言
* @export
* @param {Object} [params] - 
* @returns
*/
export async function ordermarksetBatch({ oids = [] as (string | number)[], ordermark = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/ordermarksetBatch', { oids, ordermark });
}
